// Match the existing styles convention: desktop first, mobile second.
export function normalizeModalSize(size = {}) {
  const result = { ...size }
  const axes = ['width', 'height']
  axes.forEach(axis => {
    result[axis] = [0, 1].map(index => (Array.isArray(size[axis]) ? size[axis][index] ?? '' : ''))
  })
  return result
}

export function validModalDimension(value) {
  if (value == null || String(value).trim() === '' || value === 'auto') return true
  const match = String(value).match(/^(\d+(?:\.\d+)?|\.\d+)(px|%|vw|vh|rem|em)?$/)
  return Boolean(match && Number(match[1]) > 0 && Number(match[1]) <= Number.MAX_SAFE_INTEGER)
}

export function modalDimensionParts(value) {
  const match = String(value ?? '').match(/^(.*?)(px|%|vw|vh|rem|em)$/)
  return { number: value === 'auto' ? '' : match?.[1] ?? value ?? '', unit: match?.[2] || 'px' }
}

export function modalSizeErrors(size = {}) {
  return ['width', 'height'].some(axis => (size[axis] || []).some(value => !validModalDimension(value)))
}

export function modalDimensionCss(value) {
  if (!validModalDimension(value) || value == null || String(value).trim() === '' || value === 'auto') return 'auto'
  const { number, unit } = modalDimensionParts(value)
  return `${number}${unit}`
}
